

var reviewDetail = function(modal,chapter,name,imageHost) {

    var modalDiv = $('#'+ modal);
    $(modalDiv).on('hidden.bs.modal', function (e) {
        $(modalDiv).find('.modal-content').html('');
    });


    var modalcontentstr = '<div class="modal-header">'+name+'</div>' +
        '<div class="modal-body">';
    _(chapter.answers).each(function(answer) {
        var question = answer.question;
        var colspan = (question.image_id == null) ? 1 : 2;
        modalcontentstr += '<table class="table">' +
            '<tr><td colspan="'+colspan+'" id="'+answer.id+'">'+ question.question +'</td></tr>';
        modalcontentstr += '<tr><td><ol class="review-choices">';
        if ( typeof question.choice_1 !== 'undefined') {
            modalcontentstr += writeChoice(1,question.choice_1,answer,question.correct_choice);
        }
        if ( typeof question.choice_2 !== 'undefined') {
            modalcontentstr += writeChoice(2,question.choice_2,answer,question.correct_choice);
        }
        if ( typeof question.choice_3 !== 'undefined') {
            modalcontentstr += writeChoice(3,question.choice_3,answer,question.correct_choice);
        }
        if ( typeof question.choice_4 !== 'undefined') {
            modalcontentstr += writeChoice(4,question.choice_4,answer,question.correct_choice);
        }
        if ( typeof question.choice_5 !== 'undefined') {
            modalcontentstr += writeChoice(5,question.choice_5,answer,question.correct_choice);
        }
        modalcontentstr += '</ol></td>';
        if (colspan == 2 && typeof question.image !== 'undefined') {
            modalcontentstr += '<td style="width:30%;"><img src="'+ imageHost + question.image.path + question.image.name + '-small' + question.image.ext +  '" /></td>';
        }
        modalcontentstr +='</tr>';
        // check for null before printing explanation [JayG]2023-08-02
        if ( typeof question.explanation !== 'undefined' && question.explanation !== null && question.explanation.length) {
            modalcontentstr +='<tr><td colspan="'+colspan+'">Explanation: '+question.explanation+'</td></tr>';
        }
        if ( typeof question.other_explanation !== null ) {
            modalcontentstr +='<tr><td colspan="'+colspan+'">Incorrect Explanation: '+question.other_explanation+'</td></tr>';
        }
        modalcontentstr +='</table>';
    });
        modalcontentstr +='</div>' +
        '<div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal">Close</button></div>';
    var modalContent = $.parseHTML(modalcontentstr);

    $(modalDiv).find('.modal-content').append(modalContent);



    $(modalDiv).modal();
}
function writeChoice(num,choiceText,answer,correctChoice) {
    var str = '';
    var status = '';
    var guessed = '';
    if ( typeof answer.answer !== 'undefined' && answer.answer !== null &&
        (answer.answer.indexOf(num.toString()) >= 0 || answer.answer.indexOf(num) >= 0)
    ) {
        status = answer.review_status;
        if (answer.guessed == 'yes') {
            guessed = ' ( guessed )';
        }
    }
    str += '<li class="'+ status +'">' + choiceText + guessed;
    if (correctChoice.indexOf(num.toString()) >= 0 || correctChoice.indexOf(num) >= 0) {
        str += ' <span class="glyphicon glyphicon-ok"></span>';
    }
    str += '</li>';
    return str;
}
module.exports = reviewDetail;


//////////////////
// WEBPACK FOOTER
// ./src/review_detail.js
// module id = 238
// module chunks = 0